





















































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { PollType } from '@/api/interfaces.api';
import TabMenu from './TabMenu.vue';
import draggable from 'vuedraggable';

export default Vue.extend({
  name: 'PollForm',
  components: { TabMenu, draggable },
  props: {
    onSubmit: {
      type: Function,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    pollId: {
      type: String,
      required: false,
      default: '',
    },
    presenterSessionId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    // TODO: Not working on page reload
    if (this.isEditMode && this.poll) {
      this.form = {
        title: this.poll.title,
        answerOptions: this.poll.answerOptions,
        type:
          this.poll.answerOptions.subType === 'LABELED_IMAGE_CHOICE'
            ? 'LABELED_IMAGE_CHOICE'
            : this.poll.type,
        subType: this.poll.answerOptions.subType,
        description:
          this.poll.description && this.poll.description.text
            ? this.poll.description.text
            : '',
        screenBackground: this.poll.screenBackground
          ? this.poll.screenBackground
          : { default: '' },
        choices:
          this.poll.type === PollType.SingleChoice
            ? this.poll.answerOptions.choices
            : [],
        visible: this.poll.visible ?? false,
        isPaused: this.poll.isPaused ?? false,
        order: this.poll.order,
        disableComments: this.poll.disableComments,
      };
    }
  },
  data() {
    return {
      form: {
        title: '',
        answerOptions: {
          min: null,
          max: null,
          defaultValue: null,
          step: null,
          subType: null,
          timerDuration: null,
        },
        type: PollType.SingleChoice,
        subType: '',
        choices: [] as any[],
        visible: false,
        isPaused: false,
        description: '',
        screenBackground: { default: '' },
        order: 0,
        disableComments: true,
      },
      selectedCategories: [] as string[],
      drag: false,
      choiceNumber: 0,
    };
  },
  computed: {
    ...mapGetters({
      shareURL: 'presenter/getShareURL',
      getCurrentPoll: 'presenter/getCurrentPoll',
    }),
    poll(): any {
      if (this.pollId) {
        const [poll] = this.getCurrentPoll(this.pollId);
        return poll;
      }
      return null;
    },
    isFormSubmitable(): boolean {
      const choicesState =
        this.form.choices.length > 0 &&
        this.form.choices.every(
          (choice: { id: string; value: string }) =>
            choice.id !== '' && choice.value !== ''
        );
      return (
        this.form.title !== '' &&
        ((!!this.form.answerOptions.min &&
          !!this.form.answerOptions.max &&
          !!this.form.answerOptions.defaultValue &&
          !!this.form.answerOptions.step) ||
          choicesState)
      );
    },
    tabItems(): any {
      return [
        {
          id: 0,
          name: 'Slider',
          isSelected: this.form.type == 'SLIDER',
          value: 'SLIDER',
        },
        {
          id: 1,
          name: 'Singlechoice',
          isSelected: this.form.type == 'CHOICE',
          value: 'CHOICE',
        },
        {
          id: 2,
          name: 'Image',
          isSelected: this.form.type == 'LABELED_IMAGE_CHOICE',
          value: 'LABELED_IMAGE_CHOICE',
        },
      ];
    },
  },
  methods: {
    async submitForm() {
      const formData = JSON.parse(JSON.stringify(this.form));
      if (this.form.type === 'LABELED_IMAGE_CHOICE') {
        formData.type = 'CHOICE';
        formData.subType = 'LABELED_IMAGE_CHOICE';
      }
      if (this.isEditMode) {
        await this.$store.dispatch('presenter/updatePoll', {
          form: formData,
          pollId: this.pollId,
          // pollCategories: this.selectedCategories,
        });
      } else {
        await this.$store.dispatch('presenter/createPoll', {
          form: formData,
          // pollCategories: this.selectedCategories,
        });
      }

      this.onSubmit();
    },
    selectCategory(categoryId: string) {
      this.selectedCategories = [categoryId];
    },
    onTabMenuSelect(val: PollType) {
      this.form.type = val;
    },
    addChoice() {
      const number = this.choiceNumber;
      this.form.choices.push({ id: `${this.choiceNumber}`, value: '' });
      const refs = this.$refs as any;
      if (!this.isEditMode) {
        this.$nextTick(() => refs[`choiceInput${number}`][0].focus());
      }
      this.choiceNumber++;
    },
    removeChoice(i: number) {
      this.form.choices.splice(i, 1);
      this.choiceNumber--;
    },
  },
});
